//import fetch from 'cross-fetch'

export const REQUEST_ALBUMS = 'REQUEST_ALBUMS'
export const RECEIVE_ALBUMS = 'RECEIVE_ALBUMS'
export const REQUEST_ALBUMS_SEARCH = 'REQUEST_ALBUMS_SEARCH'
export const RECEIVE_ALBUMS_SEARCH = 'RECEIVE_ALBUMS_SEARCH'
export const RESET_ACTIVE_ALBUM = 'RESET_ACTIVE_ALBUM'
export const RECEIVE_ALBUM = 'RECEIVE_ALBUM'
export const REQUEST_ALBUM = 'REQUEST_ALBUM'
export const INVALIDATE_ALBUMS = 'INVALIDATE_ALBUMS'
export const REQUEST_REVIEWS = 'REQUEST_REVIEWS'
export const RECEIVE_REVIEWS = 'RECEIVE_REVIEWS'
export const RESET_ACTIVE_REVIEW = 'RESET_ACTIVE_REVIEW'
export const RECEIVE_REVIEW = 'RECEIVE_REVIEW'
export const REQUEST_REVIEW = 'REQUEST_REVIEW'
export const INVALIDATE_REVIEWS = 'INVALIDATE_REVIEWS'
export const INVALIDATE_PODCASTS = 'INVALIDATE_PODCASTS'
export const RECEIVE_PODCASTS = 'RECEIVE_PODCASTS'
export const REQUEST_PODCASTS = 'REQUEST_PODCASTS'

export function invalidateAlbums(page) {
  return {
    type: INVALIDATE_ALBUMS,
    page: page
  }
}

function requestAlbums(page) {
  return {
    type: REQUEST_ALBUMS,
    page: page
  }
}

function receiveAlbums(json, page) {
  return {
    type: RECEIVE_ALBUMS,
    page: page,
    albums: json,
    receivedAt: Date.now()
  }
}

function fetchAlbums(page) {
  return dispatch => {
    dispatch(requestAlbums(page))
    return fetch('//jeff.4zzz.org.au/api/albums?_format=json&page=' + page)
      .then(response => response.json())
      .then(json => dispatch(receiveAlbums(json, page)))
  }
}

function shouldFetchAlbums(state, page) {
  //const albums = state.albums
  const albums = state.albums.pages[page]
  if (!albums) {
    return true
  } else if (albums.isFetching) {
    return false
  } else {
    return albums.didInvalidate
  }
}

export function fetchAlbumsIfNeeded(page) {
  return (dispatch, getState) => {
    if (shouldFetchAlbums(getState(), page)) {
      return dispatch(fetchAlbums(page))
    }
  }
}

function requestAlbumsSearch(searchterm) {
  return {
    type: REQUEST_ALBUMS_SEARCH,
    searchterm: searchterm
  }
}

function receiveAlbumsSearch(json, searchterm) {
  return {
    type: RECEIVE_ALBUMS_SEARCH,
    searchterm: searchterm,
    albums: json,
    receivedAt: Date.now()
  }
}

function fetchAlbumsSearch(searchterm) {
  return dispatch => {
    dispatch(requestAlbumsSearch(searchterm))
    return fetch('//jeff.4zzz.org.au/api/search/'+ searchterm + '/review?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveAlbumsSearch(json, searchterm)))
  }
}

function shouldFetchAlbumsSearch(state, searchterm) {
  //const albums = state.albums
  const search = state.albums.search
  if (!search.searchTerm || search.searchTerm !== searchterm) {
    return true
  } else if (search.isFetching) {
    return false
  } else {
    return search.didInvalidate
  }
}

export function fetchAlbumsSearchIfNeeded(searchterm) {
  return (dispatch, getState) => {
    if (shouldFetchAlbumsSearch(getState(), searchterm)) {
      return dispatch(fetchAlbumsSearch(searchterm))
    }
  }
}

export function resetActiveAlbum() {
  return {
    type: RESET_ACTIVE_ALBUM,
  }
}

function requestAlbum(id) {
  return {
    type: REQUEST_ALBUM,
    id: id
  }
}

function receiveAlbum(json, id) {
  return {
    type: RECEIVE_ALBUM,
    id: id,
    album: json,
    receivedAt: Date.now()
  }
}

function fetchAlbum(id) {
  return dispatch => {
    dispatch(requestAlbum(id))
    return fetch('//jeff.4zzz.org.au/reviews/albums/' + id + '?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveAlbum(json, id)))
  }
}

function shouldFetchAlbum(state, id) {
  //const albums = state.albums
  const story = state.albums.reviews[id]
  if (!story) {
    return true
  } else if (story.isFetching) {
    return false
  } else {
    return story.didInvalidate
  }
}

export function fetchAlbumIfNeeded(id) {
  return (dispatch, getState) => {
    if (shouldFetchAlbum(getState(), id)) {
      return dispatch(fetchAlbum(id))
    }
  }
}

export function invalidateReviews(page) {
  return {
    type: INVALIDATE_REVIEWS,
    page: page
  }
}

function requestReviews(page) {
  return {
    type: REQUEST_REVIEWS,
    page: page
  }
}

function receiveReviews(json, page) {
  return {
    type: RECEIVE_REVIEWS,
    page: page,
    reviews: json,
    receivedAt: Date.now()
  }
}

function fetchReviews(page) {
  return dispatch => {
    dispatch(requestReviews(page))
    return fetch('//jeff.4zzz.org.au/api/live?_format=json&page=' + page)
      .then(response => response.json())
      .then(json => dispatch(receiveReviews(json, page)))
  }
}

function shouldFetchReviews(state, page) {
  //const review = state.review
  const review = state.reviews.pages[page]
  if (!review) {
    return true
  } else if (review.isFetching) {
    return false
  } else {
    return review.didInvalidate
  }
}

export function fetchReviewsIfNeeded(page) {
  return (dispatch, getState) => {
    if (shouldFetchReviews(getState(), page)) {
      return dispatch(fetchReviews(page))
    }
  }
}

export function resetActiveReview() {
  return {
    type: RESET_ACTIVE_REVIEW,
  }
}

function requestReview(cat, id) {
  return {
    type: REQUEST_REVIEW,
    cat: cat,
    id: id
  }
}

function receiveReview(json, cat, id) {
  return {
    type: RECEIVE_REVIEW,
    cat: cat,
    id: id,
    review: json,
    receivedAt: Date.now()
  }
}

function fetchReview(cat, id) {
  return dispatch => {
    dispatch(requestReview(cat, id))
    return fetch('//jeff.4zzz.org.au/reviews/' + cat + '/' + id + '?_format=json')
      .then(response => response.json())
      .then(json => dispatch(receiveReview(json, cat, id)))
  }
}

function shouldFetchReview(state, cat, id) {
  //const review = state.review
  const story = state.reviews.reviews[id]
  if (!story) {
    return true
  } else if (story.isFetching) {
    return false
  } else {
    return story.didInvalidate
  }
}

export function fetchReviewIfNeeded(cat, id) {
  return (dispatch, getState) => {
    if (shouldFetchReview(getState(), cat, id)) {
      return dispatch(fetchReview(cat, id))
    }
  }
}


export function invalidatePodcasts(page) {
  return {
    type: INVALIDATE_PODCASTS,
    page: page
  }
}

function requestPodcasts(page) {
  return {
    type: REQUEST_PODCASTS,
    page: page
  }
}

function receivePodcasts(json, page) {
  return {
    type: RECEIVE_PODCASTS,
    page: page,
    podcasts: json,
    receivedAt: Date.now()
  }
}

function fetchPodcasts(page) {
  return dispatch => {
    dispatch(requestPodcasts(page))
    return fetch('//jeff.4zzz.org.au/api/podcasts?_format=json&page=' + page)
      .then(response => response.json())
      .then(json => dispatch(receivePodcasts(json, page)))
  }
}

function shouldFetchPodcasts(state, page) {
  //const review = state.review
  const review = state.podcasts.pages[page]
  if (!review) {
    return true
  } else if (review.isFetching) {
    return false
  } else {
    return review.didInvalidate
  }
}

export function fetchPodcastsIfNeeded(page) {
  return (dispatch, getState) => {
    if (shouldFetchPodcasts(getState(), page)) {
      return dispatch(fetchPodcasts(page))
    }
  }
}
